import { Fragment } from 'react';

import { Dialog, Transition } from '@headlessui/react';
import { mdiCheck, mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import { Typography } from '@memoresa/ui-components';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { ProductActionsButton } from '../../buttons/ProductActionsButton';

type IActionDrawer = {
  open: boolean;

  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ActionsDrawer = ({
  open,

  setIsOpen,
}: IActionDrawer) => {
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        onClose={() => setIsOpen(false)}
        className="relative z-9999"
      >
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-30"
          entered="opacity-30"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-30"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 transition-opacity bg-black" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="fixed inset-y-0 right-0 flex max-w-full sm:pl-10 ">
              <Dialog.Panel className="relative w-screen pointer-events-auto h-max sm:h-screen sm:max-w-md">
                <Transition.Child
                  as={Fragment}
                  enter="transition-transform ease-in duration-300 transform"
                  enterFrom="-translate-y-full sm:translate-x-full  sm:translate-y-0"
                  enterTo="translate-y-0 sm:translate-x-0"
                  leave="transition-transform ease-out duration-300 transform"
                  leaveFrom="translate-y-0 sm:translate-x-0"
                  leaveTo="-translate-y-full sm:translate-x-full sm:translate-y-0"
                >
                  <div
                    className={`flex flex-col justify-between bg-primary-contrast 
                          w-full p-6 overflow-hidden text-left
                          align-middle shadow-xl sm:max-w-md sm:h-full`}
                  >
                    <div className="absolute top-3 right-3">
                      <button
                        onClick={() => setIsOpen(open => !open)}
                        className="inline-flex items-center justify-center p-1 font-medium text-center transition-shadow border border-transparent rounded-full outline-none font-montserrat transition-color focus:border-primary focus:bg-primary-5 focus:outline-none hover:bg-primary-10 active:bg-primary-15"
                      >
                        <Icon
                          path={mdiClose}
                          size={0.9}
                          className="text-gray-400"
                        />
                      </button>
                    </div>
                    <div className="flex flex-col mt-4 space-y-6">
                      <div
                        data-cy={'actions-drawer-title'}
                        className="flex items-center justify-center space-x-4"
                      >
                        <Icon
                          path={mdiCheck}
                          className="text-success"
                          size={1}
                        />
                        <Typography
                          className="!font-heebo text-[26px] font-semibold"
                          color="primary"
                        >
                          {t('navigation.actionsDrawer.title')}
                        </Typography>
                      </div>
                      <div className="flex flex-col px-6 space-y-4">
                        <ProductActionsButton
                          style={{ textTransform: 'uppercase' }}
                          onClick={() => router.push('/shop/cart')}
                          data-cy={'shopping-cart-button'}
                        >
                          {t('navigation.actionsDrawer.toShoppingCart')}
                        </ProductActionsButton>
                        <ProductActionsButton
                          onClick={() => setIsOpen(false)}
                          style={{ textTransform: 'uppercase' }}
                          variant="secondary"
                          data-cy={'continue-shopping-button'}
                        >
                          {t('navigation.actionsDrawer.continueShopping')}
                        </ProductActionsButton>
                      </div>
                    </div>
                  </div>
                </Transition.Child>
              </Dialog.Panel>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
